module.exports = __webpack_public_path__ + "fonts/role-alliance-war-1f9f47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/role-alliance-war.svg
// module id = 855
// module chunks = 0